import { bytesToMegabytes, getNiceFileSize } from '../utilities'

export default class {
  constructor(el, elOptions) {
    const options = Object.assign(
      {
        disabled: false,
        maxSize: '1', // 1 mb
        maxLength: '50', // file name
        src: null,
        name: null,
        size: null,
      },
      elOptions,
      {},
    )

    const HAS_VALUE_CLASS = 'has-value'
    const DRAGOVER_CLASS = 'is-dragover'

    const inputEl = el.querySelector('.js-fileInput')
    const nameEl = el.querySelector('.js-fileName')
    const clearEl = el.querySelector('.js-fileClear')
    const imageEl = el.querySelector('.js-fileImage')
    const removeInputEl = el.querySelector('.js-fileRemoveInput')

    const defaultTextValue = nameEl.textContent

    function setValues(
      src = options.src || null,
      name = options.name || null,
      size = options.size || null,
    ) {
      if (!src) {
        inputEl.value = ''
      }

      el.classList.toggle(HAS_VALUE_CLASS, Boolean(src && src.length))

      imageEl.setAttribute('src', src || '')

      nameEl.textContent =
        name && size
          ? `${name}${size ? ` (${getNiceFileSize(size)})` : ''}`
          : defaultTextValue
    }

    setValues(options.src, options.name, options.size)

    if (options.disabled) {
      inputEl.disabled = true
      clearEl.disabled = true

      if (removeInputEl) {
        removeInputEl.disabled = true
      }

      return
    }

    let prevValue = imageEl?.files?.length && imageEl.files[0]

    function handleChange(e) {
      el.classList.remove(DRAGOVER_CLASS)

      const hasValue = e.target.files && e.target.files[0]

      if (hasValue) {
        if (imageEl) {
          let reader = new FileReader()

          reader.onload = function (ev) {
            if (validate(e.target.files[0])) {
              setValues(
                ev.target.result,
                e.target.files[0].name,
                e.target.files[0].size,
              )

              prevValue = e.target.files[0]
            } else {
              if (!prevValue) {
                inputEl.value = ''
              }

              e.preventDefault()
              return false
            }
          }

          reader.readAsDataURL(e.target.files[0])
        }
      } else {
        setValues()
      }
    }

    function validate(file) {
      if (!validateFileType(file.type)) {
        inputEl.setCustomValidity(`Filtypen ${file.type} är inte tillåten.`)
        inputEl.reportValidity()

        return false
      } else if (!validateSize(file.size)) {
        inputEl.setCustomValidity(
          `Filen är för stor (${getNiceFileSize(file.size)}). Maxstorlek är ${
            options.maxSize
          } MB.`,
        )
        inputEl.reportValidity()

        return false
      } else if (!validateFileName(file.name)) {
        inputEl.setCustomValidity(
          `Filen har för långt namn (${file.name}). Maxlängden är ${options.maxLength} tecken.`,
        )
        inputEl.reportValidity()
      }

      inputEl.setCustomValidity('')
      return true
    }

    function validateFileType(fileType) {
      const accepted = inputEl.getAttribute('accept')

      if (accepted) {
        const allowed = accepted.split(',')

        return (
          allowed.includes(fileType) ||
          allowed.includes(fileType.split('/')[0] + '/*')
        )
      }

      return true
    }

    function validateFileName(fileName) {
      return fileName.length < 50
    }

    function validateSize(size) {
      return (
        !options.maxSize || bytesToMegabytes(size) < Number(options.maxSize)
      )
    }

    function handleClear(e) {
      e.preventDefault()
      e.stopPropagation()

      const clearValues = imageEl.getAttribute('src').length > 0

      if (clearValues) {
        setValues('', null, null)

        if (removeInputEl) {
          removeInputEl.setAttribute('checked', true)
        }
      } else {
        inputEl.click()
      }
    }

    inputEl.addEventListener('reset', handleClear)
    inputEl.addEventListener('change', handleChange)
    clearEl.addEventListener('click', handleClear)

    el.addEventListener('dragover', function () {
      el.classList.add(DRAGOVER_CLASS)
    })

    el.addEventListener('dragleave', function () {
      el.classList.remove(DRAGOVER_CLASS)
    })
  }
}
